import React, { useState } from 'react'
import { connect } from 'react-redux'
import './index.css'

import { withRouter } from '../../utils/withRouter'
import { InputText } from '../../shared/CustomField'
import { Form } from 'react-form'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [successSendEmail, setSuccessSendEmail] = useState(false)
  // ponte V2: sob /v2 o link do e-mail e o "voltar" ficam no chrome V2
  const isV2 = window.location.pathname.startsWith('/v2')

  // Form validation
  const _validateForm = (values) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    
    return {
      email: !values.email 
        ? 'Email é obrigatório' 
        : !emailRegex.test(values.email) 
        ? 'Por favor, insira um email válido' 
        : undefined
    }
  }

  // Function to handle forgot password submission
  const handleForgotPassword = async (values) => {
    setIsLoading(true)
    setMessage('')
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APPSETTING_SM_PHP_API_ENDPOINT}users/password/reset`,
        {
          email: values.email,
          ...(isV2 ? { origin: 'v2' } : {}),
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data.status === 200) {
        setMessage('Um email com instruções para alterar sua senha foi enviado!')
        setSuccessSendEmail(true)
        setMessageType('success')
      } else {
        setMessage(response.data.message || 'Erro ao enviar email. Tente novamente.')
        setMessageType('error')
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message || 'Erro ao enviar email. Tente novamente.'
      )
      setMessageType('error')
    } finally {
      setIsLoading(false)
    }
  }

  // Function to go back to home
  const goToHome = () => {
    navigate(isV2 ? '/v2/conta/entrar' : '/')
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-page__content">
        {!successSendEmail ? (
          <>
            <h1>Esqueci a senha</h1>
            <p>Digite seu email abaixo e enviaremos instruções para alterar sua senha.</p>

            {message && messageType === 'error' && (
              <div className={`forgot-password-page__message ${messageType}`}>
                {message}
              </div>
            )}

            <Form
              validate={_validateForm}
              onSubmit={handleForgotPassword}
            >
              {({ submitForm, values }) => {
                return (
                  <form onSubmit={(e) => { e.preventDefault(); submitForm(); }}>
                    <div className="forgot-password-page__content__fields-box">
                      <label>
                        Email*
                        <InputText 
                          type="email" 
                          className="field__text" 
                          field="email"
                          placeholder="Digite seu email"
                        />
                      </label>

                      <div className="forgot-password-page__content__fields-box__buttons">
                        <button 
                          className="button__normal button__normal--cancel" 
                          type="button" 
                          onClick={goToHome}
                          disabled={isLoading}
                        >
                          Voltar
                        </button>
                        <button 
                          className="button__normal" 
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? 'Enviando...' : 'Alterar senha'}
                        </button>
                      </div>
                    </div>
                  </form>
                )
              }}
            </Form>
          </>
        ) : (
          <div className="forgot-password-page__success">
            <div className="forgot-password-page__success__icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <rect x="8" y="15" width="64" height="40" rx="4" stroke="#e74c3c" strokeWidth="2" fill="none"/>
                <path d="M8 25 L40 45 L72 25" stroke="#e74c3c" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Email enviado com sucesso!</h2>
            <p>
              Enviamos um link para redefinição de senha para seu email. 
              <br />
              Verifique sua caixa de entrada e também a pasta de spam.
            </p>
            <div className="forgot-password-page__success__buttons">
              <button 
                className="button__normal" 
                type="button" 
                onClick={goToHome}
              >
                Voltar ao início
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = {}

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...props,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ForgotPassword))
